import { render, staticRenderFns } from "./myCovertDetail.vue?vue&type=template&id=54adbd6f&scoped=true"
import script from "./myCovertDetail.vue?vue&type=script&lang=js"
export * from "./myCovertDetail.vue?vue&type=script&lang=js"
import style0 from "./myCovertDetail.vue?vue&type=style&index=0&id=54adbd6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54adbd6f",
  null
  
)

export default component.exports